import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const PHONE_COUNTRY_CODE_SCHEMA_FIELD_NAMES = {
  PHONE_COUNTRY_CODE: "phoneCountryCode",
};

export const getPhoneCountryCodeFormFieldSchema = (
  label = i18n("PhoneCountryCodeFormField__LABEL")
) => yup.number().required().label(label);
